module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"dealTime":"成交日期","shipping":"运费"},"zh_hk":{"dealTime":"成交日期","shipping":"運費"},"en":{"dealTime":"Transaction time","shipping":"Shipping"},"ja":{"dealTime":"取引日","shipping":"貨物"}}')
  delete Component.options._Ctor
}
